import type { IOrganizationAccessWebForm } from './OrganizationAccessWebForm.interface';

export default class OrganizationAccessWebForm implements IOrganizationAccessWebForm {
  kind: string;
  type: string;
  label: string;
  referrer: string;
  primary: string;
  background: string;
  text: string;
  error: string;
  simple: boolean;
  hasCallToAction: boolean;
  callToAction: string;
  callToActionButton: string;
  callToActionURL: string;

  static build = (data: IOrganizationAccessWebForm) => new OrganizationAccessWebForm(data);
  static blank = (data: IOrganizationAccessWebForm) =>
    new OrganizationAccessWebForm({ ...data });

  getUrl = () => {
    let url = '';
    _.forIn(this, (v, k) => {
      if (typeof v === 'function' || v === undefined) {
        return;
      }
      url += `&${k}=${encodeURI(v)}`;
    });
    return url;
  };

  /**
   * Constructor
   * @param {IOrganizationAccessWebForm} data
   */
  constructor(data?: IOrganizationAccessWebForm) {
    this.kind = data?.kind || undefined;
    this.type = data?.type || undefined;
    this.label = data?.label || undefined;
    this.referrer = data?.referrer || undefined;
    this.primary = data?.primary || undefined;
    this.background = data?.background || undefined;
    this.text = data?.text || undefined;
    this.error = data?.error || undefined;
    this.simple = data?.simple === true;
    this.hasCallToAction = data?.hasCallToAction === true;
    this.callToAction = data?.callToAction || undefined;
    this.callToActionButton = data?.callToActionButton || undefined;
    this.callToActionURL = data?.callToActionURL || undefined;
  }
}
